/**
 * TCR-2664 — hằng số dùng chung cho mọi ô tìm sản phẩm (POS, danh sách SP, picker...).
 * Gom một chỗ để chữ hướng dẫn và độ trễ gõ không lệch nhau giữa các màn.
 */

/** Độ trễ (ms) sau lần gõ cuối trước khi bắn request tìm kiếm. */
export const SEARCH_DEBOUNCE_MS = 300;

/** Placeholder ô tìm sản phẩm không có phím tắt (drawer, picker nhỏ). Nhắc rõ có thể gõ cả TÊN. */
export const PRODUCT_SEARCH_PLACEHOLDER_PLAIN = 'Tên / Mã SP / Barcode...';

/** Placeholder ô tìm POS khi KHÔNG bật theo dõi serial. */
export const PRODUCT_SEARCH_PLACEHOLDER = `${PRODUCT_SEARCH_PLACEHOLDER_PLAIN} (F3)`;

/** Placeholder ô tìm POS khi bật theo dõi serial (có thêm QR/serial). */
export const PRODUCT_SEARCH_PLACEHOLDER_SERIAL = `QR / ${PRODUCT_SEARCH_PLACEHOLDER}`;

/** Thông báo khi API tìm kiếm lỗi — khác với "không tìm thấy". */
export const SEARCH_ERROR_TEXT = 'Không tải được, thử lại';

/** Thông báo khi tìm kiếm thành công nhưng không có kết quả. */
export const SEARCH_EMPTY_TEXT = 'Không tìm thấy sản phẩm phù hợp';
